import * as dataSourceExports from "@mecatran/datasource"
import {UtilsArray} from "../utils/index.mjs";


var { DataLoaderOptions, DataParserOptions,DataDeserializerOptions, DataSource,DataSourceOptions } = dataSourceExports;



export class BanSource{
    constructor(banSourceOptions){
        var _center = [],
            _query = ''
        ;

        Object.defineProperty(this,'center',{
            set : function(c){ _center =c },
            get : function(){ return _center }
        }); 

        Object.defineProperty(this,'query',{
            set : function(q){ _query = q },
            get : function(){ return _query  }
        });


        this.initBanSource(banSourceOptions);

    }

    // ==========
    // private 
    // ----------
    setName(n){ this.name = n }

    getName(){ return this.name }


    setDataSource(dataSource){ this.dataSource = dataSource }
    getDataSource(){ return this.dataSource }

    buildUrl(){
        var limit = 10;
        var center = this.center;
        var query = this.query || '';
        var url; 
        var lat = center[0], lon = center[1];
        if (this.query !== ''){
            url =  `https://api-adresse.data.gouv.fr/search?q=${this.query}&type=street&limit=${limit}`;
        } else return; 
        if ((lat && lon)) url += `&lat=${lat}&lon=${lon}`;
        console.log(url)
        return url;
    }

    getFeatures(geojson){
        return geojson.features;
    }

    featureToStopLiteral(feature){  
        var stopLiteral = {};
        stopLiteral.name = feature.properties.name;
        stopLiteral.city = feature.properties.city;
        stopLiteral.lat = feature.geometry.coordinates[1];
        stopLiteral.lon = feature.geometry.coordinates[0];
        return stopLiteral;        
    }

    addTransformers(options){
        var transformer = this.getDataSource().getTransformer();
        transformer.add(this.getFeatures)
        transformer.add(UtilsArray.processAll(this.featureToStopLiteral))
    }

    initDataSource(banSourceOptions){
        var url;
        //url ="https://api-adresse.data.gouv.fr/search?q=Rue%20Andr%C3%A9%20boulloche%20valdoie%20Belfort&limit=10&type=street"; 
        var cache = false;
        var parserType = 'json';
        var dataSourceOptions = Object.assign(new DataSourceOptions(),{ 
            name : 'banDataSource',
            dataLoaderOptions : new DataLoaderOptions({url, cache}),
            dataParserOptions : new DataParserOptions({parserType }),
            dataDeserializerOptions : undefined,
            dataTransformerOptions : undefined
        });
        var dataSource = new DataSource(dataSourceOptions);
        dataSource.setName('ban-source')
        this.setDataSource(dataSource);       
    }

    initBanSource(banSourceOptions){
        this.initDataSource();
        this.addTransformers();
    }

    // ==========
    // public
    // ---------
    get(){ return this.getDataSource().get() }

    setQuery(query){
        var loader = this.getDataSource().getDataLoader();
        this.query = query; 
        loader.setUrl(this.buildUrl()); 
    }

    // center = [lat, lon]
    setCenter(center){ 
        var loader = this.getDataSource().getDataLoader();
        if (center) this.center = center; 
        loader.setUrl(this.buildUrl());
    }
}


/**
 * BanSourceOptions interface
 * --------------------------
 * bounds : []
 */